// General
import "./product-purchase.scss";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
// Services
import {
  useLazyGetProfileQuery,
  useLazyGetVirtualCurrencyCoinBalanceQuery,
  usePurchaseProductMutation,
} from "../../../../services/data.service";
// Static Data
import routeConst from "../../../../const/routeConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateProductPurchaseDialog } from "../../../../redux/store/dialogStore";
import { updatePurchaseDialogTab } from "../../../../redux/store/productsStore";
// React Swipeable Views
import SwipeableViews from "react-swipeable-views/lib/SwipeableViews";
// Material UI
import { Tabs, Tab, Box, useTheme } from "@mui/material";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";
// i18next
import { useTranslation } from "react-i18next";
// Custom Hooks
import useCustomNavigate from "../../../utility/custom-hooks/useCustomNavigate-hook";
import IconManager from "../../../utility/manager/icon-manager/icon-manager";
// Components
import CoinsTab from "../../dialog-content/product-purchase-dialog/coins-tab/coins-tab";
import GiftsTab from "../../dialog-content/product-purchase-dialog/gifts-tab/gifts-tab";
import PopularTab from "../../dialog-content/product-purchase-dialog/popular-tab/popular-tab";
import TipMenuTab from "../../dialog-content/product-purchase-dialog/tip-menu-tab/tip-menu-tab";

const ProductPurchase = (props) => {
  const { state } = props;

  // API variables
  const [
    getProfile,
    {
      data: getProfileData,
      error: getProfileErrorData,
      isFetching: getProfileFetching,
      isLoading: getProfileLoading,
      isSuccess: getProfileSuccess,
      isError: getProfileError,
    },
  ] = useLazyGetProfileQuery();
  const [
    getCoins,
    {
      data: getCoinsData,
      error: getCoinsErrorData,
      isFetching: getCoinsFetching,
      isLoading: getCoinsLoading,
      isSuccess: getCoinsSuccess,
      isError: getCoinsError,
    },
  ] = useLazyGetVirtualCurrencyCoinBalanceQuery();
  const [
    purchaseProduct,
    {
      data: purchaseProductData,
      error: purchaseProductErrorData,
      isLoading: purchaseProductLoading,
      isSuccess: purchaseProductSuccess,
      isError: purchaseProductError,
    },
  ] = usePurchaseProductMutation();

  // General variables
  const [view, setView] = useState(null);
  const [showSendButton, setShowSendButton] = useState(false);
  const [page, setPage] = useState("");

  // Redux variables
  const purchaseDialogTab = useSelector(
    (state) => state.products.purchaseDialogTab
  );
  const livestreamerId = useSelector(
    (state) => state.livestreaming.livestreamerId
  );
  const livestreamerUsername = useSelector(
    (state) => state.livestreaming.livestreamerUsername
  );
  const selectedGift = useSelector((state) => state.livestreaming.selectedGift);
  const requestId = useSelector((state) => state.privateCall.requestId);
  const calleeId = useSelector((state) => state.privateCall.calleeId);
  const callerId = useSelector((state) => state.privateCall.callerId);
  const isDaddy = useSelector((state) => state.user.isDaddy);
  const dispatch = useDispatch();

  // MUI variables
  const theme = useTheme();

  // Router variables
  const location = useLocation();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();
  const getIcon = IconManager();

  // Lifecycle | Mounted
  useEffect(() => {
    // getProfile(null, true);
    // getCoins();
  }, []);

  // Lifecycle | Check for update | Purchase Product API Response
  useEffect(() => {
    if (purchaseProductLoading) {
    } else if (purchaseProductSuccess) {
      if (purchaseProductData?.status === 0) {
        dispatch(updateProductPurchaseDialog(false));
      }
    } else if (purchaseProductError) {
      if (purchaseProductErrorData?.status === 401) {
        // onNavigate(routeConst.logout.path);
      }
    }
  }, [purchaseProductLoading, purchaseProductSuccess, purchaseProductError]);

  // Lifecycle | Check for update | location
  useEffect(() => {
    if (!location) return;

    if (location.pathname.includes("live")) {
      setView("live");
      setPage("livestream");
    } else if (location.pathname.includes("video-call")) {
      setPage("private-call");
      if (isDaddy) {
        setView("caller");
      } else {
        setView("callee");
      }
    }
  }, [location]);

  // Lifecycle | Check for update | view
  useEffect(() => {
    switch (view) {
      case "live":
        setShowSendButton(purchaseDialogTab !== 0);
        break;
      case "caller":
        setShowSendButton(purchaseDialogTab === 1);
        break;
      case "callee":
        setShowSendButton(false);
        break;
      default:
        setShowSendButton(false);
    }
  }, [purchaseDialogTab, view]);

  // Event Handlers | Button
  const onSendGift = () => {
    if (location?.pathname.includes("live")) {
      const obj = {
        payment_gateway: "virtual_currency",
        product_hash_id: selectedGift,
        recipient_user_id: livestreamerId,
      };

      purchaseProduct(obj);
    } else if (location?.pathname.includes("video-call")) {
      if (isDaddy) {
        const obj = {
          payment_gateway: "virtual_currency",
          product_hash_id: selectedGift,
          recipient_user_id:
            getProfileData?.data?.id === calleeId ? callerId : calleeId,
          related_id: requestId,
          related_module: "private_calls",
        };

        purchaseProduct(obj);
      }
    }
  };
  const onMoveToCoinShop = () => {
    dispatch(updatePurchaseDialogTab(0));
  };

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateProductPurchaseDialog(false));
  };

  // Event Handlers | MUI Tabs
  const onTabChange = (event, newValue) => {
    dispatch(updatePurchaseDialogTab(newValue));
  };
  const onTabChangeBySwipe = (index) => {
    dispatch(updatePurchaseDialogTab(index));
  };

  // Utility Functions
  const getFormattedCoins = (coins) => {
    if (coins >= 100000) {
      return `${(coins / 1000).toFixed(1)}K`;
    } else {
      return coins?.toLocaleString();
    }
  };

  return (
    <div id="product-purchase-subcomponent">
      <div className="padding-container">
        {state === "dialog" && (
          <div className="header-container">
            <div className="left-container"></div>
            <div className="middle-container">
              {view === "live"
                ? t("live.gifts_for_user", { name: livestreamerUsername })
                : t("live.tips")}
            </div>
            <div className="right-container">
              <div className="close-icon-container" onClick={onCloseDialog}>
                <CloseIcon className="close-icon" />
              </div>
            </div>
          </div>
        )}

        <div
          className={`tab-container ${state === "dialog" ? "" : "headerless"}`}
        >
          <Tabs
            className="custom-tabs"
            value={purchaseDialogTab}
            onChange={onTabChange}
            TabIndicatorProps={{ style: { backgroundColor: "#710d0d" } }}
            variant="fullWidth"
          >
            {location?.pathname.includes("live") && (
              <Tab label={t("1on1.coins")} {...a11yProps(0)} />
            )}
            {location?.pathname.includes("video-call") && isDaddy && (
              <Tab label={t("1on1.coins")} {...a11yProps(0)} />
            )}
            <Tab
              label={t("1on1.gifts")}
              {...a11yProps(
                location?.pathname.includes("live")
                  ? 1
                  : isDaddy
                  ? 1
                  : !isDaddy
                  ? 0
                  : 1
              )}
            />
            {location?.pathname.includes("live") && (
              <Tab label={t("1on1.popular")} {...a11yProps(2)} />
            )}
            {location?.pathname.includes("video-call") && isDaddy && (
              <Tab label={t("1on1.tip_menu")} {...a11yProps(2)} />
            )}
          </Tabs>

          <SwipeableViews
            className="swipeable-container"
            containerStyle={{
              transition: "transform 0.35s cubic-bezier(0.15, 0.3, 0.25, 1) 0s",
            }}
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={purchaseDialogTab}
            onChangeIndex={onTabChangeBySwipe}
          >
            <TabPanel
              className="tab-panel"
              value={purchaseDialogTab}
              index={0}
              dir={theme.direction}
            >
              {location?.pathname.includes("live") && <CoinsTab />}
              {location?.pathname.includes("video-call") && isDaddy && (
                <CoinsTab state={state} />
              )}
              {location?.pathname.includes("video-call") && !isDaddy && (
                <GiftsTab state={state} page={page} />
              )}
            </TabPanel>

            <TabPanel
              className="tab-panel"
              value={purchaseDialogTab}
              index={1}
              dir={theme.direction}
            >
              <GiftsTab state={state} page={page} />
            </TabPanel>

            <TabPanel
              className="tab-panel"
              value={purchaseDialogTab}
              index={2}
              dir={theme.direction}
            >
              {location?.pathname.includes("live") && <PopularTab />}
              {location?.pathname.includes("video-call") && isDaddy && (
                <TipMenuTab state={state} />
              )}
            </TabPanel>
          </SwipeableViews>
        </div>

        <div className="bottom-container">
          <div className="balance-container" onClick={onMoveToCoinShop}>
            <div className="add-icon-container">
              {getIcon("liveAddCoinIcon", "add-icon")}
            </div>

            <div className="balance-label">{t("common.balance")}:</div>

            <div className="coin-icon-container">
              {getIcon("sbCoinIcon", "coin-icon")}
            </div>

            <div className="coin-value">
              {getFormattedCoins(getCoinsData?.data?.balance)}
            </div>
          </div>

          {showSendButton && (
            <div className="send-button" onClick={onSendGift}>
              {t("common.send")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductPurchase;

// Material UI | Tab Functions
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      // hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }} className="tab-box-container">
          {children}
          {/* <Typography component={"div"}>{children}</Typography> */}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
